import React from "react";
import styles from "./styles";
import { withStyles } from "@material-ui/core/styles";
import { Typography, Button } from "@material-ui/core";
import CustomTextField from "../../common/CustomTextField";
import PackageItems from "../../common/PickupComponents/PackageItems";
import { MAX_VALUE_CONSTRAINTS, MIN_VALUE } from "../../common/constants";

const PackageDetails = ({
  classes,
  editInfo,
  errorInfo,
  packageTypeList,
  handleChange,
  addItem,
}) => {
  return (
    <div id="packageDetails" className={classes.packageDetailsSection}>
      <Typography variant="subtitle1" className={classes.headerLabel}>
        PACKAGING DETAILS
      </Typography>
      <div className={classes.flexRowWithSpacing}>
        <CustomTextField
          className={classes.huInput}
          id="pieces"
          handleChange={handleChange("pieces")}
          value={editInfo.pieces}
          error={errorInfo.pieces}
          label="Pieces"
          inputProps={{
            min: MIN_VALUE.PICKUP_PRO_FORM.PIECES,
            max: MAX_VALUE_CONSTRAINTS.PICKUP_PRO_FORM.PIECES,
          }}
          type="number"
        />
        <CustomTextField
          className={classes.packageTypeInput}
          id="weight"
          handleChange={handleChange("weight")}
          value={editInfo.weight}
          error={errorInfo.weight}
          label="Weight"
          inputProps={{
            min: MIN_VALUE.PICKUP_PRO_FORM.WEIGHT,
            max: MAX_VALUE_CONSTRAINTS.PICKUP_PRO_FORM.WEIGHT,
          }}
          type="number"
        />
      </div>
      {editInfo.packagingItems.map((item, index) => (
        <PackageItems
          key={`packageItems_${index}`}
          handleChange={handleChange}
          errorInfo={errorInfo}
          editInfo={editInfo}
          packageTypeList={packageTypeList}
          index={index}
          packageCode={item.packageCode}
        />
      ))}
      <Button
        autoFocus
        color="primary"
        variant="outlined"
        className={classes.actionButton}
        onClick={addItem}
      >
        add item
      </Button>
    </div>
  );
};

export default withStyles(styles)(PackageDetails);
